import React, { useState, useEffect } from 'react';

const ZahaNavigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      scrolled 
        ? 'bg-white/95 backdrop-blur-xl shadow-sm' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="flex items-center justify-between">
          <a href="#" className="text-2xl font-light tracking-wider text-[#2d3748] hover:text-[#4a5568] transition-colors">
            ABNER PALLICHAN
          </a>

          <div className="hidden md:flex items-center gap-12">
            {[
              { href: '#work', label: 'Work' },
              { href: '#music', label: 'Music' },
              { href: '#contact', label: 'Contact' }
            ].map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="relative text-sm font-medium text-[#718096] hover:text-[#2d3748] tracking-wide group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#2d3748] group-hover:w-full transition-all duration-500" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default ZahaNavigation;